export default {
  title: {
    formTitle: "権限タイプ",
    listTitle: "権限タイプ一覧",
    createTitle: "作成",
    editTitle: "編集",
  },
  listHeader: {
    roleName: "権限タイプ名",
    officeableType: "会社区分",
    officeName: "会社名",
    departmentName: "組織名",
    updatedAt: "最終更新日",
    updatedBy: "最終更新者",
    form: "編集",
    delete: "削除",
  },
  search: {
    officeType: "会社区分",
    managementOffice: "管理会社",
    subManagementOffice: "準管理会社",
    operationOffice: "運営会社",
    installationOffice: "設置会社",
    department: "組織",
    role: "権限タイプ名",
  },
  modal: {
    message: "権限タイプを削除します。よろしいですか？",
    submitBtn: "削除",
    cancelBtn: "キャンセル",
  },
  form: {
    name: "権限タイプ名",
    companyName: "会社名",
    departmentName: "組織名",
    permission: "権限",
    template: "テンプレート",
    selectTemplate: "テンプレートから選択",
    action:{
      all:    "全て",
      read:   "閲覧",
      create: "作成",
      update: "更新",
      delete: "削除",
      output: "出力",
      input:  "入力",
    },
    button:{
      apply: "適用"
    },
    mask:{
      needSelect: "会社名または組織名を選択してください",
      loading: "読み込み中"
    },
    permissionItems:{
      dailyReport:{
        suffix: "（特例適用）"
      }
    }
  },
  validate:{
    officeFormEmpty: "所属組織を入力してください",
    departmentFormEmpty: "組織を入力してください"
  }
}
